"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPrincipalBalancePointInTimeQueryParams = void 0;
const common_1 = require("@finley-technologies/common");
const formula_engine_1 = require("@finley-technologies/formula-engine");
const createPrincipalBalancePointInTimeQueryParams = ({ postgresQuery, }) => {
    const { parameterConfig, variables } = postgresQuery;
    const { dateFormula } = parameterConfig;
    try {
        const date = formula_engine_1.commonFormulas.evaluateDateFormula({
            dateFormula: dateFormula.formula,
            variables,
        });
        return {
            isValid: true,
            params: { date },
        };
    }
    catch (err) {
        const errorMessage = `Detected error while creating Principal Balance Point in Time Query params [error:${(0, common_1.getErrorMessage)(err)}`;
        return {
            isValid: false,
            errors: [errorMessage],
        };
    }
};
exports.createPrincipalBalancePointInTimeQueryParams = createPrincipalBalancePointInTimeQueryParams;
//# sourceMappingURL=principalBalancePointInTimeQueryParams.js.map